export default {
  data() {
    return {
      form: {
        fileList: [], //upload多文件数组
      },
      radioValue: "",
      tableData: [],
      currentPage: 1, //当前分页展示页码。
      paginationShow: false, //解决换Tab页时的页码显示不正确的bug。
      pageSizes: [10], //当前表格每页展示的数据条数。
      totalRows: 0, //数据总条数。
    };
  },
  mounted() {},
  methods: {
    demolitionStatsModifyBox_close() {
      this.$emit("demolitionStatsModify_close");
    },
    downloadAquisitionDetail() {},
    uploadFile() {},
    getCurrentRow(index, row) {},
    handleCurrentChange(val) {
      this.currentPage = val;
      //this.initData();
      console.log(`当前页: ${val}`);
    },
    save() {
      //alert(1);
      this.$emit("demolitionStatsModify_close");
    },
  },
  watch: {},
  destroyed() {},
};
